import { Button } from 'components/button/Button'
import { Icon } from 'components/icon'
import { SectionEmptyState } from 'components/sectionEmptyState/SectionEmptyState'
import { useStoryPortraitLogic } from 'components/storyPortraits/logic'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

export const StoryPortraitsPlaceholder: FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation('life_stories')

  const logic = useStoryPortraitLogic()
  const chooseImageButton = logic.useChooseImageButton()
  const selfieButton = logic.useSelfieButton()

  return (
    <>
      {chooseImageButton.modal}
      {selfieButton.modal}
      <SectionEmptyState
        icon="ImageAdd"
        title={t('life_stories.inside_page.gallery_empty.title')}
        description={t('life_stories.inside_page.gallery_empty.desc')}
        buttons={
          <>
            <Button
              onClick={selfieButton.onClick}
              type="button"
              variant="secondary"
              leftIcon={<Icon name="Camera" />}
            >
              {t('life_stories.inside_page.gallery_empty.selfie_button')}
            </Button>
            <Button onClick={chooseImageButton.onClick} type="button">
              {t('life_stories.inside_page.gallery_empty.story.action_button')}
            </Button>
          </>
        }
      />
    </>
  )
}
